module.exports = __webpack_public_path__ + "static/media/light-blue-bell-icon.3e0835f5.svg";